import googleMaps from '../api/googleMaps';
import { getPOIAirports } from '../api';

let googleMapLocationTrack = {};

let map;

function toGenerateDynamicMarkers(googleMapLocationTrack, catName, infowindow, parentIndex) {
  //This code is responsible for generating dynamic markers on click
  var ar = JSON.parse(googleMapLocationTrack["airportLocs" + catName] || "[]");//Add hotel with items, so we need concat
  ar.forEach((location, index)=> {
    if ((location.lat && location.lng) || (location.latitude && location.longitude)) {
    location.location = {
    lat: location.lat? Number(location.lat): Number(location.latitude),
    lng: location.lng? Number(location.lng): Number(location.longitude)
  }
  map = googleMaps.returnMapInstance();
  location.id = ''+parentIndex+index;
  //Fallback code when map is not available
  if(!map) {
    //There is no proper first init on google map here we need to recreate the map
       map = new window.google.maps.Map(document.getElementById('map-destination'), {
        zoom: 1,
        center: location
      });
      //Set the global google mapper object, try to recreate map instance 
      googleMaps.createMapInstance();
  }
    googleMaps.addMarker({
      map,
      infowindow,
      location
    })
    }
  });
}

function markersClear(removeAll) {
  $.each(googleMaps.markers, (index)=> {
    if (index === 0 && !removeAll) {
      return;
    }
    googleMaps.markers[index].setMap(null);
 }); 
}

function setMarker() {
  const markerId = this.getAttribute('data-id');
  let targetMarker;
  if(googleMaps.markers && googleMaps.markers.length > 0) {
      targetMarker = googleMaps.markers.find((marker) => {
          return marker.id === markerId; 
      })
  }
  if(targetMarker) {
      google.maps.event.trigger(targetMarker, 'click');
  }
}


const propertyLevel = {
  filtered: null,
  theme: [],
  poi: {
    airports: []
  },
  init({ API_KEY, hotels, theme }) {
    this.API_KEY = API_KEY;
    this.hotels = hotels;
    this.theme = theme;
    if ($(document.body).hasClass('location')) {
      this.mapCanvas();
      this.getAirports();
    }
    this.$collapsed = $('.maps-accordion-collapsed');
    setTimeout(() => {
      if (window.innerWidth < 1025) {
        this.$collapsed.removeClass('hidden');
      } else {
        $('.maps-accordion').removeClass('hidden');
      }
    }, 500);
    $(window).on('resize', () => {
      if (window.innerWidth < 1025) {
        if (this.$collapsed.hasClass('hidden')) {
          //$('#wrapper').addClass('hidden');
          $('#wrapper1').addClass('hidden');
        }
      } else {
        $('#wrapper').removeClass('hidden');
      }
    });
    this.toggleAccordion();
    this.slick();
    this.culinary();
    markersClear();
  },
  mapCanvas() {
    const propertyPhgId = $('#hotel-search').attr('data-phgid');
    let filteredArray = [];
    const propertyInfo = this.hotels.find(h => h.phg_id === propertyPhgId);
    if(propertyInfo) {
      filteredArray.push(propertyInfo);
      this.filtered = filteredArray;
    }

    googleMaps.init({
      API_KEY: this.API_KEY,
      filteredMap: this.filtered,
      propertyLevel: true,
      theme: this.theme
    });
  },
  getAirports(){
    getPOIAirports(this.filtered[0].phg_id).then(data => {
    let airportLocaitons;
    const arr = Object.keys(data);
    var category = [];
    var airportLocs = [];
    for (let i = 0; i < arr.length; i++) {
      let eachObj = data[arr[i]];
      category.push('<li><a data-collapsed="true" class="airports-trigger1 is-accordion-submenu-parent" href="#" data-value="' + arr[i] + '" >' + arr[i] + '</a>');
      category.push(`<ul data-id=${i} class="airports menu vertical nested submenu is-accordion-submenu" >`);
      if (eachObj && eachObj.length > 0) {
        airportLocaitons = eachObj.map((placeName, index) => {
          category.push(`<li><a href="#" data-id=${i}${index}><span class="countryIndex">${placeName.countryIndex}</span>${placeName.title}</a></li>`);
          return placeName;
        });
        
      /*-----------------Commented for avoiding hotel to get added to every accordion list-----*/
      //  airportLocs = this.hotels.filter(h => h.value === $singleHotelInputValue).concat(airportLocaitons);
      /*------------------------End-------------------------*/

          airportLocs = airportLocaitons;

        googleMapLocationTrack["airportLocs" + arr[i]] =  JSON.stringify(airportLocs);
      }
      category.push('</ul>');
      category.push('</li>');
      this.poi.airports = airportLocs;
      $('.maps-accordion .airports-trigger').html(category.join(''));
      $('.airports-trigger1').on('click', function () {
        /*Clearing off the previous markers from the map*/
        if(googleMaps.markers && googleMaps.markers.length > 0) {  
          markersClear(); 
        }
        /*End*/
        $(this).closest('li').siblings().find('.airports').removeClass('showMenu');
        $(this).next('.airports').toggleClass('showMenu');
        var catName = $(this).attr('data-value');
        if ($('.airports-trigger ul').hasClass('showMenu')) {   
          $(this).data('collapsed', false);
        //   $.each(googleMaps.markers, (index)=> {
        //     googleMaps.markers[index].setMap(null);
        //  });
        //  googleMaps.markers.length = 0;
          const parentIndex = this.parentElement.getElementsByTagName('ul')[0].getAttribute('data-id');
          const infowindow = new window.google.maps.InfoWindow();
          toGenerateDynamicMarkers(googleMapLocationTrack, catName, infowindow, parentIndex);
        } else {
          $(this).data('collapsed', true);
          if(googleMaps.markers && googleMaps.markers.length > 0) {  
            markersClear(); 
          }
        }
      });

      /*---------------------When user clicks on indiviual li in Showmenu accordion-----------------------------*/
      $('.airports li a').on('click', function() {
        setMarker.call(this); // bind the current instance
      })

      $('.maps-accordion-wrap .accordion-menu .airports li>a').on('click', function() {
        if (window.innerWidth < 1025) {
            $('.maps-accordion-wrap .close').trigger('click'); // close the overlay
            setMarker.call(this); // bind the current instance
            // Google map Location marker
            var catName = $(this).closest('ul').siblings('.airports-trigger1').attr('data-value');
            const infowindow = new window.google.maps.InfoWindow();
            const parentIndex = $(this).closest('ul').attr('data-value');
            toGenerateDynamicMarkers(googleMapLocationTrack, catName, infowindow, parentIndex);
        }
      })
      /*--------------------End----------------------------*/

    }
  })
  },

 

  toggleContent() {
    $('.maps-accordion-wrap .maps-accordion').toggleClass('hidden');
    $('.maps-accordion-wrap .maps-accordion-collapsed').toggleClass('hidden');

    // if (window.innerWidth < 1025) {
    //   $('#wrapper').toggleClass('hidden');
    // }
  },

  toggleAccordion() {
    //Event dinding on the init call
    $('.maps-accordion-wrap .maps-toggle').on('click', () => {
      this.toggleContent();
      if($('.maps-accordion').hasClass('hidden'))
      {
      //  clear the markers when all cat collapsed
        // if(googleMaps.markers && googleMaps.markers.length > 0) {  
        //   markersClear();
        // }
        $('.gm-ui-hover-effect').trigger('click');
        if(googleMaps.markers && googleMaps.markers.length > 0) {  
          googleMaps.markers.map((marker, index) => {
            if(index===0) {
              return;
            }
            if (marker.infowindow) {
              marker.infowindow.close();
            }
            marker.setVisible(false);
          })
        }
      } else{
         if ($('.airports-trigger ul').hasClass('showMenu')) {
              //var catName = $('.showMenu').siblings().attr('data-value');
              //const parentIndex = this.parentElement.getElementsByTagName('ul')[0].getAttribute('data-id');
              //const infowindow = new window.google.maps.InfoWindow();
              //toGenerateDynamicMarkers(googleMapLocationTrack, catName, infowindow, 0);
              if(googleMaps.markers && googleMaps.markers.length > 0) {  
                googleMaps.markers.map(marker => {
                  marker.setVisible(true);
                })

              }
         }
      }   
    });
  },

  slick() {
    if ($(document.body).hasClass('accommodations')) {
      try {
        $('.accommodations-slick').not('.slick-initialized').slick();
      } catch(e) {
        console.error('Error in slick ' + e);
      }
    }
  },

  culinary() {
    const $diningImage = $('.dining-image');
    $diningImage.on('click', function() {
      $diningImage
          .not(this)
          .find('.dining-image-modal')
          .addClass('hidden');

      $(this)
          .find('.dining-image-modal')
          .toggleClass('hidden');
    });

    const $offerBtn = $('.offers .cta .learn-more');
    $offerBtn.on('click', function() {
      $(this)
          .parent()
          .prev()
          .find('.offer-modal')
          .toggleClass('hidden');
      if($(this).html() == "View Details")
      {
        $(this).html("LEARN MORE");
      }
    });
  }
};

export default propertyLevel;
